/* eslint-disable camelcase */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';
import uniqueId from 'lodash/uniqueId';
import isNull from 'lodash/isNull';

import { TextInput } from './listInputs/TextInput';
import DateInput from './listInputs/DateInput';
// import SelectInput from './listInputs/SelectInput';
import TableRow from '../../common/table/TableRow';

import { ExecutionDetailsContext } from '../../../containers/dataValidation/executionDetails/ExecutionDetailsContext';
import StyleForm from '../../common/input/Form.styled';
// import StateHelper from '../../../helpers/stateHelper';

import CalendarIcon from '../../../assets/images/calender-icon.svg';
import DataValidationHelper from '../../../helpers/features/DataValidationHelper';

const CannabisLicensesDetailsListRow = ({
  data,
  fieldErrors,
  handleFieldUpdate,
  handleFieldError,
  editedEntryFields,
}) => {
  const { id } = data;

  const { isApproved, initialEntryTableData, editedEntriesInitData } =
    useContext(ExecutionDetailsContext);

  const handleFieldValueChange = updatedValue => {
    const entryData = initialEntryTableData.filter(entry => entry.id == id)[0];

    handleFieldUpdate(id, entryData, updatedValue);
  };

  const getInitialDateValue = key => {
    const entryData = editedEntriesInitData.filter(entry => entry.id == id)[0];

    if (entryData?.[key]) return entryData?.[key];
    return null;
  };

  const validateField = fieldData => {
    switch (fieldData.key) {
      case 'license_details':
        if (fieldData?.value?.length > 500) {
          handleFieldError(id, {
            key: 'license_details',
            value: 'You have exceeded the character limit',
          });
        } else {
          handleFieldError(id, { key: 'license_details', value: '' });
        }
        break;
      default:
        break;
    }
  };

  return (
    <TableRow key={uniqueId()}>
      {DataValidationHelper.CANNABIS_LICENCES_DETAILS_TABLE.map(field => {
        switch (field.type) {
          case 'text':
            return (
              <td key={`${id}-${field.db_key}`}>
                <TextInput
                  id={`${id}-${field.db_key}`}
                  name={field.db_key}
                  value={data[field.db_key]}
                  placeholder={data[field.db_key] ? '' : '-'}
                  handleUpdate={value => handleFieldValueChange({ key: field.db_key, value })}
                  edited={
                    editedEntryFields?.[id]?.values &&
                    Object.keys(editedEntryFields[id].values).includes(field.db_key)
                  }
                  disabled={isApproved}
                />
              </td>
            );
          case 'date':
            return (
              <td key={`${id}-${field.db_key}`}>
                <StyleForm>
                  <div className="admin-filter-datepicke">
                    <DateInput
                      id={`${id}-${field.db_key}`}
                      name={field.db_key}
                      value={data[field.db_key]}
                      handleUpdate={value => handleFieldValueChange({ key: field.db_key, value })}
                      getInitialValue={getInitialDateValue}
                      edited={
                        editedEntryFields?.[id]?.values &&
                        Object.keys(editedEntryFields[id].values).includes(field.db_key)
                      }
                      disabled={isApproved}
                    />
                    {isNull(field.db_key) && <Image src={CalendarIcon} />}
                  </div>
                </StyleForm>
              </td>
            );
          default:
            return null;
        }
      })}
    </TableRow>
  );
};

CannabisLicensesDetailsListRow.propTypes = {
  data: PropTypes.object.isRequired,
};

export default CannabisLicensesDetailsListRow;
